export default "__VITE_ASSET__e2ec541f__"